import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function CustomerStep3Admin({ formData, onChange }) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">
        Create the primary admin account for this customer:
      </p>

      <div className="space-y-2">
        <Label className="text-slate-700 dark:text-slate-300">Full Name <span className="text-red-500">*</span></Label>
        <Input
          value={formData.admin_name}
          onChange={(e) => onChange('admin_name', e.target.value)}
          placeholder="John Doe"
          className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
          data-testid="admin-name-input"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-slate-700 dark:text-slate-300">Email <span className="text-red-500">*</span></Label>
          <Input
            type="email"
            value={formData.admin_email}
            onChange={(e) => onChange('admin_email', e.target.value)}
            placeholder="admin@company.com"
            className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
            data-testid="admin-email-input"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-slate-700 dark:text-slate-300">Phone</Label>
          <Input
            value={formData.admin_phone}
            onChange={(e) => onChange('admin_phone', e.target.value)}
            placeholder="+91 98765 43210"
            className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label className="text-slate-700 dark:text-slate-300">Password <span className="text-red-500">*</span></Label>
        <Input
          type="password"
          value={formData.admin_password}
          onChange={(e) => onChange('admin_password', e.target.value)}
          placeholder="Min 6 characters"
          className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
          data-testid="admin-password-input"
        />
        <p className="text-xs text-slate-500 dark:text-slate-400">
          This user will have full admin access to the Customer Ops Portal
        </p>
      </div>
    </div>
  );
}
